import styled from 'styled-components';
import { itemTitleColor } from 'utils/theme';

export const ErrorWrapper = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${itemTitleColor};

  button {
    margin-right: 21px;
    margin-bottom: 28px;
  }
`;

export const ErrorTitle = styled.h1`
  font-size: 44.2px;
  line-height: 1.4;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 24.88px;
    margin-bottom: 14px;
  }
`;

export const ErrorText = styled.p`
  margin-bottom: 28px;

  @media (min-width: 768px) {
    font-size: 18.66px;
  }
`;
